import { AppStateProvider, simpleEffect } from 'app/shared/app_state/AppStateProvider';
import { TerrainService } from 'app/map/services/terrain.service';

export const k_TERRAIN_LOADED = 'terrain_and_zone_labels_loaded';

// You should subscribe to this class if you want to be notified of when the terrain has changed AND
// 'dependant' functions have run. As of 22/12/21 this means the subscribers to this class will be
// notified only once the zone labels have finished updating and the locations have been sampled. If
// you don't care about that, feel free to just subscribe to the TerrainService
export class TerrainLoadedStateProvider {
    private _state: AppStateProvider;
    private _terrainService: TerrainService;
    // run through the task queue after a terrain change event
    // all tasks must complete before we declare the map ready to use
    private _taskQueue: Array<() => Promise<void>>;

    constructor(terrainService: TerrainService) {
        this._taskQueue = [];
        this._terrainService = terrainService;

        this._terrainService.subscribeChangeOfTerrain(async () => {
            await this._setTerrainLoaded(false);
            for await (const fn of this._taskQueue) {
                await fn();
            }
            await this._setTerrainLoaded(true);
        });

        this._state = new AppStateProvider({
            keys: {
                [k_TERRAIN_LOADED]: {
                    initialValue: true,
                    defaultValue: true,
                },
            },
            effects: {
                setTerrainAndZoneLabelsLoaded: simpleEffect((state, loaded) => ({
                    [k_TERRAIN_LOADED]: loaded,
                })),
            },
        });
    }

    public setTerrainLoadedListener(fn: (state) => void): () => void {
        return this._state.onChange(fn);
    }

    public addTaskToTerrainStateChangeQueue(fn: () => Promise<void>): void {
        this._taskQueue.push(fn);
    }

    private async _setTerrainLoaded(val: boolean): Promise<void> {
        return this._state.effects.setTerrainAndZoneLabelsLoaded(val);
    }
}
